export default "__VITE_ASSET__2415e5ff__"